<template>
    <div class="side-nav-panel grid grid__base" :class="mainNavigationStateFacet">
        <div class="side-nav-panel--panel-content-wrapper">
            <div class="side-nav-panel--panel">
                <div class="side-nav-panel--panel-content">
                    <nav-panel-content :items="items" :facets="['side-nav']"/>
                </div>
                <meta-nav class="side-nav-panel--metanav" :facets="['mobile']" v-bind="metanav"/>
            </div>
        </div>
    </div>
</template>

<script>
    import NavPanelContent from 'framework/components/navigation/mobile-navbar/nav-panel-content/nav-panel-content';
    import { mapActions, mapState } from 'vuex';
    import NavPanelMeta from 'framework/components/navigation/mobile-navbar/nav-panel-meta/nav-panel-meta';

    import bemMixin from 'framework/mixins/bem';
    import MetaNav from 'framework/global-components/dyn/navigation/meta-nav/meta-nav';

    export default {
        components: { MetaNav, NavPanelMeta, NavPanelContent },
        mixins: [bemMixin('side-nav-panel')],
        props: {
            /** @type {INavigationEntry[]} */
            items: {
                type: Array,
                required: true,
            },
        },

        computed: {
            ...mapState('navigation', ['mainVisible', 'metanav']),

            mainNavigationStateFacet() {
                return this.bemAdd(this.mainVisible ? 'main-header' : 'reduced-header');
            },
        },

        methods: {
            ...mapActions('overlay', ['closeOverlay']),
        },
    };
</script>
